import { takeLatest, put, delay, call, takeEvery } from 'redux-saga/effects';


import * as TYPES from '../actions/types';
import { getClientSign, loaderAction,  saveClientClnic, saveClientPendingQuestionnaires, saveClientQuestinnaires, saveClientSign, saveGenericSuccessData, saveParentInfo } from '../actions';
import { GenericResponseModel } from '../../dataModel/authModels';
import { client } from '../../services/clientService';
import { auth } from '../../services/authService';



export function* getClientSignSaga() {
  try {
    yield takeLatest(TYPES.GET_CLIENTS_SIGN, getClientSignSagaActions);
  } catch (err) {
  }
}

function* getClientSignSagaActions(param:any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield client.getSign();
    yield put(saveClientSign(response.resultData));
    yield put(loaderAction(false));
  }catch(e){
  }
}


export function* getClientClinicSaga() {
  try {
    yield takeLatest(TYPES.GET_CLIENT_CLINIC, getClientClinicSagaActions);
  } catch (err) {
  }
}

function* getClientClinicSagaActions(param:any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield client.getClinicInfo();
    yield put(saveClientClnic(response.resultData));
    yield put(loaderAction(false));
  }catch(e){
  }
}


export function* getClientDocSaga() {
  try {
    yield takeLatest(TYPES.GET_CLIENT_DOC, getClientDocActions);
  } catch (err) {
  }
}

function* getClientDocActions(param:any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield client.getClientDocument();
    yield put(saveClientClnic(response.resultData));
    yield put(loaderAction(false));
  }catch(e){
  }
}

export function* updateCLientSignsSaga() {
  try {
    yield takeLatest(TYPES.UPDATE_CLIENT_SIGN, updateClientSignworker);
  } catch (err) {
  }
}

function* updateClientSignworker(param:any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield client.updateSign(param['payload']);
    yield put(saveGenericSuccessData(true));
    yield put(getClientSign());
    yield put(loaderAction(false));
  }catch(e){
  }
}

export function* updateSignPinSaga() {
  try {
    yield takeLatest(TYPES.UPDATE_CLIENT_SIGN_PIN, updatePinWorker);
  } catch (err) {
  }
}

function* updatePinWorker(param:any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield client.updateSignPIN(param['payload']);
    // yield put(saveGenericSuccessData(true));
    // yield put(getClientSign());
    yield put(loaderAction(false));
  }catch(e){
  }
}

export function* getParentInfoSaga() {
  try {
    yield takeLatest(TYPES.GET_PARENT_INFO, parentWorker);
  } catch (err) {
  }
}

function* parentWorker(param:any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield auth.getParentInfo();
    // yield put(saveGenericSuccessData(true));
    yield put(saveParentInfo(response.resultData));
    yield put(loaderAction(false));
  }catch(e){
  }
}

export function* getClientQuestionnairesSaga() {
  try {
    yield takeEvery(TYPES.GET_CLIENT_QUESTIONNAIRES, getClientQuestionnairesWorker);
  } catch (err) {
  }
}

function* getClientQuestionnairesWorker(param: any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield auth.getClientQuestionnaires(param['payload']);
    if (response?.status) {
      if(param['payload'].isCompleted) {
        yield put(saveClientQuestinnaires(response));
      }
      else {
        yield put(saveClientPendingQuestionnaires(response));
      }
  }
  
  } catch (e) {
    console.error("Error fetching client questionnaires:", e);
  } finally {
    yield put(loaderAction(false));
  }
}
